import { ScrollArea } from "@base-ui/react/scroll-area"
import React, { useMemo } from "react"

import { GlobalSearchResultType } from "features/global-search/types/GlobalSearch"

import { useGlobalSearchContext } from "../../GlobalSearchContext"
import { GlobalSearchListbox } from "../GlobalSearchListbox"
import { ProjectGlobalSearchListItem } from "../list-items/ProjectGlobalSearchListItem"

export const GlobalSearchProjectTab = React.memo(() => {
  const { options, activeTab } = useGlobalSearchContext()
  const isTabActive = activeTab === GlobalSearchResultType.PROJECT

  const items = useMemo(
    () => options[GlobalSearchResultType.PROJECT]?.options ?? [],
    [options]
  )

  return (
    <div className="global-search__tab-content global-search__project-tab">
      <ScrollArea.Root className="scroll-area scroll-area--vertical shadow-s global-search__scroll-area">
        <ScrollArea.Viewport className="scroll-area__viewport">
          <ScrollArea.Content className="scroll-area__content">
            <GlobalSearchListbox>
              {items.map((item, index) => (
                <ProjectGlobalSearchListItem
                  key={item.key ?? item.value}
                  option={item}
                  index={index}
                  isTabActive={isTabActive}
                />
              ))}
            </GlobalSearchListbox>
          </ScrollArea.Content>
        </ScrollArea.Viewport>
        <ScrollArea.Scrollbar
          orientation="vertical"
          className="scroll-area__scrollbar"
        >
          <ScrollArea.Thumb className="scroll-area__thumb" />
        </ScrollArea.Scrollbar>
      </ScrollArea.Root>
    </div>
  )
})
